import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';

import { AuthProvider } from './../../providers/auth/auth';

import { MyProfilePage } from './../my-profile/my-profile';
import { PrivacySettingsPage } from './../privacy-settings/privacy-settings';
import { BankDetailsPage } from './../bank-details/bank-details';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage implements OnInit {
  title = 'Settings';
  fbUser: any;
  user: any;
  userSubscription: any;
  userDataLoaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private afAuth: AngularFireAuth
  ) {}

  ngOnInit() {
    this.authProvider.getFbUser().then(fbUser => {
      console.log(fbUser);
      this.userSubscription = this.authProvider
        .getUserByUid(fbUser.uid)
        .subscribe(
          data => {
            console.log(data);
            this.user = data;
            this.userDataLoaded = true;
            return data;
          },
          err => {
            console.log(err);
          }
        );
    });
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  openMyProfile() {
    this.navCtrl.push(MyProfilePage);
  }

  openPrivacySettings() {
    this.navCtrl.push(PrivacySettingsPage);
  }

  openBankDetails() {
    this.navCtrl.push(BankDetailsPage);
  }

  logout() {
    this.afAuth.auth.signOut().then(() => {
      console.log('signing out');
      this.userSubscription.unsubscribe();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts